module.exports = __webpack_public_path__ + "img/gpay.4e4974cf.svg";